import React from "react";
import { Modal } from "antd";
import { l } from "../../../../config/language";
import { get, nodeFactory } from "../../../../utils/index";

const content = function (props, file) {
  const src = get(file, ["thumbUrl", "url"], "");
  const delPreviewRender = get(props, "delPreview", null);
  const type = get(props, "type", "imgs");
  const node = nodeFactory(delPreviewRender);
  if (node) {
    return node;
  } else if (["img", "imgs"].includes(type)) {
    return <img style={{ maxWidth: "100%" }} src={src} />;
  } else if (type === "video") {
    return <video style={{ maxWidth: "100%" }} src={src}></video>;
  }
  return null;
};

/**
 * 构建具有模态框的删除
 *
 * @param {*} props
 * @param {*} file
 * @param {*} { resolve, reject }
 */
const renderModal = function (props, file, { resolve, reject }) {
  Modal.confirm({
    title: props.message.delTitle(file),
    okText: l("YxModal.ot", this),
    cancelText: l("YxModal.ct", this),
    content: content(props, file),
    onOk: () => {
      get(props, "onRemoveOk", () => {})();
      resolve();
    },
    onCancel: () => {
      get(props, "onRemoveCancel", () => {})();
      reject();
    },
  });
};

/**
 * 展示删除按钮
 *
 * @export
 * @param {*} props
 * @param {*} file
 * @returns
 */
export default function (props, file) {
  return new Promise((resolve, reject) => {
    const isConfirmDel = get(props, "isConfirmDel", true);
    if (isConfirmDel) {
      renderModal(props, file, { resolve, reject });
    } else {
      resolve();
    }
  });
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Components/DelPreview.js